import './Telegram.css';
import { FaTelegramPlane } from 'react-icons/fa';

function Telegram() {
    return (
        <div id="tg-icon">
            <FaTelegramPlane />
        </div>
    );
}

export default Telegram;